import { render, staticRenderFns } from "./GroupExecutiveBoardList.vue?vue&type=template&id=90cf2aa6"
import script from "./GroupExecutiveBoardList.vue?vue&type=script&lang=js"
export * from "./GroupExecutiveBoardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports